const module = { name: 'theater/showtimes/expandedSearch', exports: {} }; const exports = module.exports;



import { global_consts as global_consts_CookieNames } from 'require-core';

const { CookieNames } = global_consts_CookieNames;


import { Fandango_cookie as Fandango_cookie_get_getCookie_set_setCookie } from 'require-core';

const { get: getCookie, set: setCookie } = Fandango_cookie_get_getCookie_set_setCookie;


import { Fandango_debugLog as debugLog } from 'require-core';

function getZipList() {
    return getCookie(CookieNames.EXPANDED_SEARCH, { autojson: true }) || [];
}
function useExpanded(zip) {
    if (!zip) {
        return false;
    }
    const zipList = getZipList();
    if (!zipList.length) {
        return false;
    }
    const useExpandedSearch = zipList.includes(zip);
    if (useExpandedSearch) {
        debugLog.info(`${module.name}: Use expanded search for "${zip}"`);
    }
    return useExpandedSearch;
}
function setExpanded(zip) {
    if (!zip) {
        return;
    }
    const zipList = getZipList();
    if (!zipList.includes(zip)) {
        zipList.push(zip);
        setCookie(CookieNames.EXPANDED_SEARCH, zipList, { autojson: true });
    }
}
module.exports = {
    useExpanded,
    setExpanded,
};
export default module.exports;